import React, { useState } from "react";

const Accordion = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="border border-gray-300 rounded-md">
      <div
        className={`flex items-center justify-between px-4 py-2 cursor-pointer bg-gray-100 hover:bg-gray-300 transition-all duration-300
        ${isOpen ? "bg-sky-900 hover:bg-sky-900 text-white" : ""}
        `}
        onClick={toggleAccordion}
      >
        <h2 className="text-lg font-bold text-left">{title}</h2>
        <svg
          className={`w-6 h-6 transform ${
            isOpen ? "rotate-180" : ""
          } transition-transform duration-300`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? "h-auto" : "h-0"
        }`}
      >
        <div className="py-2 bg-white">
          <div className="text-gray-600">{content}</div>
        </div>
      </div>
    </div>
  );
};

export default Accordion;
